"use strict";

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLogger = void 0;

var use_effect_once_1 = require("./use-effect-once");

var use_update_effect_1 = require("./use-update-effect");

function useLogger(componentName) {
  var rest = [];

  for (var _i = 1; _i < arguments.length; _i++) {
    rest[_i - 1] = arguments[_i];
  }

  use_effect_once_1.useEffectOnce(function () {
    console.log.apply(console, __spreadArrays([componentName + " mounted"], rest));
    return function cleanup() {
      console.log.apply(console, __spreadArrays([componentName + " unmounted"], rest));
    };
  });
  use_update_effect_1.useUpdateEffect(function () {
    console.log.apply(console, __spreadArrays([componentName + " updated"], rest));
  });
}

exports.useLogger = useLogger;